/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './device-manufacurer.reducer';

export const DeviceManufacurerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const deviceManufacurerEntity = useAppSelector(state => state.deviceManufacurer.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="deviceManufacurerDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.deviceManufacurer.detail.title">DeviceManufacurer</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.id">Id</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.code">Code</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.code}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.description">Description</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.description}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.name">Name</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.name}</dd>
          <dt>
            <span id="country">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.country">Country</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.country}</dd>
          <dt>
            <span id="address">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.address">Address</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.address}</dd>
          <dt>
            <span id="website">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.website">Website</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.website}</dd>
          <dt>
            <span id="helpdesk">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.helpdesk">Helpdesk</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.helpdesk}</dd>
          <dt>
            <span id="gstCode">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.gstCode">Gst Code</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.gstCode}</dd>
          <dt>
            <span id="regCode">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.regCode">Reg Code</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.regCode}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.deviceManufacurer.active">Active</Translate>
            </span>
          </dt>
          <dd>{deviceManufacurerEntity.active ? 'true' : 'false'}</dd>
        </dl>
        <Button tag={Link} to="/device-manufacurer" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/device-manufacurer/${deviceManufacurerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DeviceManufacurerDetail;
